import React from 'react';

const Privacy = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-8 font-serif">Privacy Policy</h1>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6 leading-relaxed">
              Last updated: January 2026
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">1. Information We Collect</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              We collect information that you provide directly to us, including name, email address, phone number, company information, and any other information you choose to provide when contacting us or using our services.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">2. How We Use Your Information</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              We use the information we collect to provide, maintain, and improve our services, communicate with you, and comply with legal obligations.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">3. Information Sharing</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              We do not sell, trade, or rent your personal information to third parties. We may share information only as necessary to provide our services or as required by law.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">4. Data Security</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">5. Your Rights</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              You have the right to access, update, or delete your personal information. Please contact us to exercise these rights.
            </p>
            <h2 className="text-2xl font-bold text-black mt-8 mb-4 font-serif">6. Contact Us</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              If you have questions about this Privacy Policy, please contact us through our contact page.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Privacy;
